import * as React from "react"
import Map, { Marker, NavigationControl } from "react-map-gl"
import { MAPBOX_TOKEN, MAP_STYLE } from "../../constants"

import "mapbox-gl/dist/mapbox-gl.css"

import mapboxgl from "mapbox-gl" // This is a dependency of react-map-gl even if you didn't explicitly install it
import Pin from "../../components/Map/Pin"

mapboxgl.workerClass =
  // eslint-disable-next-line import/no-webpack-loader-syntax
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default

export default function CollectionMap() {
  return (
    <div style={{ width: "100%" }}>
      <Map
        initialViewState={{
          latitude: -34.39,
          longitude: 115.3,
          zoom: 8,
        }}
        mapStyle={MAP_STYLE}
        mapboxAccessToken={MAPBOX_TOKEN}
        style={{ width: "100%", height: 400 }}
      >
        <Marker longitude={115.157031} latitude={-34.369722} anchor="bottom">
          <Pin size={20} />
        </Marker>
        <Marker longitude={115.539398} latitude={-34.422655} anchor="bottom">
          <Pin size={20} />
        </Marker>

        <NavigationControl />
      </Map>
    </div>
  )
}
